



























































































































































































































































































































import {
  Component, Prop, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ToolMixin from '@/mixins/Tool.vue';
import utils from '@/services/utils';
import GeneralModule from '@/store/modules/General';
import BankAccountModule from '@/store/modules/BankAccount';
import cryptoAccountModule from '@/store/modules/CryptoAccount';
import { IfetchCryptoAccount } from '@/interface/CryptoInterface';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ReportModule from '@/store/modules/Report';

@Component({
  components: {},
})
export default class MemberBody extends Mixins(ErrorHandleMixin, ToolMixin) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  BankAccountInstance = getModule(BankAccountModule, this.$store);

  cryptoAccountInstance = getModule(cryptoAccountModule, this.$store);

  ReportInstance = getModule(ReportModule, this.$store);

  modalBank = false;

  modalAddbank = false;

  isBank = true;

  isUSDT = false;

  date = '';

  bankName = '';

  accountName = '';

  accountNo = '';

  cryptoSelect = '';

  rebate = null;

  rateUSDT = null;

  dataInvoice: any = [];

  checkTransaction = [];

  accountBank = [];

  accbank = [];

  filterSelectedBank = [];

  selectNumber = [];

  checkboxWinlose = false;

  dateSelect = '';

  crytptoFetch: Array<IfetchCryptoAccount> = [
    {
      _id: '',
      address: '',
      network: '',
      currency: '',
      imagePath: '',
    },
  ];

  @Prop() readonly startdate: any;

  @Prop() readonly enddate: any;

  @Prop() readonly data: any;

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly mainRole!: string;

  utilsInstance = utils;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
  };

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchperiod() {
    const datestart = this.$moment(this.Period.start.date).format('L');
    this.dateSelect = this.$moment(datestart).format('DD-MM-YYYY');
  }

  modeBank() {
    this.isUSDT = false;
    this.isBank = true;
  }

  async modeUSDT() {
    this.isUSDT = true;
    this.isBank = false;
  }

  async selectBank() {
    this.modalBank = !this.modalBank;
    this.accountBank = await this.BankAccountInstance.FetchBankAccount();
    const { data } = await this.cryptoAccountInstance.FetchCryptoAccount();
    this.crytptoFetch = data;
  }

  selectBankname() {
    const selectBank = this.bankName;
    this.filterSelectedBank = this.accountBank.filter((item: any) => item.namebank === selectBank);
  }

  prepareData(data, event) {
    if (event.target.checked) {
      this.dataInvoice.push(data);
    } else {
      this.dataInvoice = this.dataInvoice.filter((v) => v._id !== data._id);
    }
  }

  checkWinlose(event: { target: { checked: boolean } }) {
    this.checkboxWinlose = event.target.checked;
  }

  handleSub(username: string, role: string, source: string) {
    this.fetchWinloseAgent(username, role, source);
  }

  async exportFileExcel() {
    this.GeneralInstance.toggleLoading(true);
    this.date = this.dateSelect;
    const crytptoData = this.crytptoFetch.filter((item: any) => item._id === this.cryptoSelect);
    const sDate = this.$moment(this.startdate, 'DD-MM-YYYY').startOf('month').format('MMM Do');
    const eDate = this.$moment(this.enddate, 'DD-MM-YYYY').endOf('month').format('Do YYYY');
    const cbWinlose = this.checkboxWinlose;
    this.dataInvoice.map(async (v) => {
      const dataDetail = {
        bankName: this.bankName,
        accountName: this.accountName,
        accountNo: this.accountNo,
        dateOfBank: this.date,
        rebate: this.rebate || 0,
        isBank: this.isBank,
        rateUSDT: this.rateUSDT,
        dataInvoice: {
          commission: v.marketing,
          total: v.total,
          winLose: v.winlose,
          username: v.username,
          winLoseMember: v.rawWinlose,
        },
        startDate: sDate,
        endDate: eDate,
        checkboxWinlose: cbWinlose,
        crytptoData,
      };
      const fileName = `${v.username}_${sDate}-${eDate}`;
      await this.ReportInstance.generateFileExcel(dataDetail);
      const url = URL.createObjectURL(new Blob([this.ReportInstance.dataFile.dataFile], {
        type: 'application/vnd.ms-excel',
      }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      this.GeneralInstance.toggleLoading(false);
      this.resetData();
    });
  }

  async exportFilePdf() {
    this.GeneralInstance.toggleLoading(true);
    this.date = this.dateSelect;
    const crytptoData = this.crytptoFetch.filter((item: any) => item._id === this.cryptoSelect);
    const sDate = this.$moment(this.startdate, 'DD-MM-YYYY').startOf('month').format('MMM Do');
    const eDate = this.$moment(this.enddate, 'DD-MM-YYYY').endOf('month').format('Do YYYY');
    const cbWinlose = this.checkboxWinlose;
    this.dataInvoice.map(async (v) => {
      const dataDetail = {
        bankName: this.bankName,
        accountName: this.accountName,
        accountNo: this.accountNo,
        dateOfBank: this.date,
        rebate: Number(this.rebate) || 0,
        isBank: this.isBank,
        rateUSDT: Number(this.rateUSDT) || 0,
        dataInvoice: {
          commission: v.marketing,
          total: v.total,
          winLose: v.winlose,
          username: v.username,
          winLoseMember: v.rawWinlose,
        },
        startDate: sDate,
        endDate: eDate,
        checkboxWinlose: cbWinlose,
        crytptoData,
      };
      const fileName = `${v.username}_${sDate}-${eDate}`;
      await this.ReportInstance.generateFilePdf(dataDetail);
      const url = URL.createObjectURL(new Blob([this.ReportInstance.dataFile.dataFile], {
        type: 'application/pdf',
      }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      this.GeneralInstance.toggleLoading(false);
      this.resetData();
    });
  }

  resetData() {
    this.bankName = '';
    this.accountName = '';
    this.accountNo = '';
    this.rebate = null;
  }
}
